import { ApiAgentUser } from '../api';

export interface AppAgentUser {
    partnerId: number;
    type: number;
    partnerName: string;
    uniqueName: string;
    contactPersonFirstName: string;
    contactPersonLastName: string;
    phoneNumber: string;
    companyUniqueId: string | null;
    email: string;
    address1: string | null;
    address2: string | null;
    city: string | null;
    stateId: number | null;
    countryId: number | null;
    zipCode: string | null;
    notes: string | null;
    isActive: boolean;
    commission: string | null;
    allowInvoice: boolean;
    website: string;
    country: string | null;
    state: string | null;
    isParentCompany: boolean | null;
    isCruiseLine: boolean | null;
    shipCompanyId: string | null;
    isTaxable: boolean | null;
}

export function fromApiAgentUsers(agentUsers: ApiAgentUser[]): AppAgentUser[] {
    return agentUsers.map((agentUser) => fromApiAgentUser(agentUser));
}

export function fromApiAgentUser(agentUser: ApiAgentUser): AppAgentUser {
    return {
        partnerId: agentUser.PartnerId,
        type: agentUser.Type,
        partnerName: agentUser.PartnerName,
        uniqueName: agentUser.UniqueName,
        contactPersonFirstName: agentUser.ContactPersonFirstName,
        contactPersonLastName: agentUser.ContactPersonLastName,
        phoneNumber: agentUser.PhoneNumber,
        companyUniqueId: agentUser.CompanyUniqueId,
        email: agentUser.Email,
        address1: agentUser.Address1,
        address2: agentUser.Address2,
        city: agentUser.City,
        stateId: agentUser.StateId,
        countryId: agentUser.CountryId,
        zipCode: agentUser.ZipCode,
        notes: agentUser.ZipCode,
        isActive: agentUser.IsActive,
        commission: agentUser.Commission,
        allowInvoice: agentUser.AllowInvoice,
        website: agentUser.Website,
        country: agentUser.Country,
        state: agentUser.State,
        isParentCompany: agentUser.IsParentCompany,
        isCruiseLine: agentUser.IsCruiseLine,
        shipCompanyId: agentUser.ShipCompanyId,
        isTaxable: agentUser.IsTaxable,
    };
}
